import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Destinations from "../components/Destinations";
import Transfers from "../components/Transfers";
import Experiences from "../components/Experiences";
import WhyUs from "../components/WhyUs";
import BookingForm from "../components/BookingForm";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Destinations />
        <Transfers />
        <Experiences />
        <WhyUs />
        <BookingForm />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
}
